$(document).ready(function(){

  //   FLICKITY IN BLOG PAGE

  window.addEventListener('load', function(){
    $('.main-carousel-1').flickity({
      // options
      cellAlign: 'left',
      contain: true
    });
  });


  //   MENU BAR HOVER

  $('ul.h-main-nav li').mouseenter(function() {
    var $this = $(this);
    $this.children('.new-d-block').css("display", "block");
    $('.main-nav-list').removeClass('active');
    $('.a1').addClass("hov");
  })
  .mouseleave(function() {
    var $this = $(this);
    $this.children('.new-d-block').css("display", "none");
    $('.a1').removeClass("hov");

  });

  
  //   NAV BAR 

   
  $('.hdr-selector').click(function(){
    $(this).toggleClass("change");
    $('.h-nav-wrapper').toggleClass("nav-open");
    $('.bg-op').css("display","block");
    $('.h-sub-nav > li').removeClass("not-active-sub").removeClass("active-sub");

  });

  $('.icon1').click(function(){
    $(this).toggleClass("change1");
    $('.h-nav-wrapper').removeClass("nav-open");
    $('.bg-op').css("display","none");
    $('.h-sub-nav').removeClass("active");
    $('.h-sub-nav').children('.h-sub-nav > li').removeClass("active-sub");
    $('.h-sub-nav').children('.h-sub-nav > li').removeClass("not-active-sub");
    $('.h-sub-nav').children('.h-sub-nav > li').children('a').removeClass("active-sub-a");
    $('.h-sub-nav.mob').addClass("notactive")
  });


});